var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome24Bold = function SvgHome24Bold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.457 3.665a3 3 0 0 0-2.914 0l-8.028 4.46a1 1 0 1 0 .97 1.75L4 9.587V16a5 5 0 0 0 5 5h6a5 5 0 0 0 5-5V9.588l.515.286a1 1 0 1 0 .97-1.748l-8.028-4.46ZM9 18v-1a3 3 0 1 1 6 0v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })));
};
export default SvgHome24Bold;